const setAnswer = function (qu, valueMap) {
  let id = this.id
  let value = valueMap[id]
  value = value || null

  if (value instanceof Array && value.length === 1) {
    value = parseInt(value[0])
  }

  this.value = value
  if (this.value !== null) {
    this.tmpValue = this.value
  }
}

const answer = {
  setAnswer
}

export default answer



// WEBPACK FOOTER //
// ./src/components/editor/NpsBox/answer.js